// Dark theme colors - Grafana-inspired
const darkColors = {
  background: {
    default: "#111217", // Grafana bg-canvas
    paper: "#181b1f",   // Grafana bg-primary
  },

  text: {
    main: "#9da5b0",
    focus: "#9da5b0",
    primary: "#e9edf2",
    secondary: "#9da5b0",
    disabled: "#6b7280",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#3CAEA3", // Thaklis teal
    state: "#20827a",
    contrastText: "#ffffff",
  },

  secondary: {
    main: "#22252b",
    focus: "#2c3039",
    contrastText: "#e9edf2",
  },

  info: {
    main: "#5794F2", // Grafana blue
    focus: "#6ba1f3",
    contrastText: "#ffffff",
  },

  success: {
    main: "#73BF69", // Grafana green
    focus: "#8ac882",
    contrastText: "#ffffff",
  },

  warning: {
    main: "#FF9830", // Grafana orange
    focus: "#ffa94d",
    contrastText: "#000000",
  },

  error: {
    main: "#F2495C", // Grafana red
    focus: "#f56876",
    contrastText: "#ffffff",
  },

  light: {
    main: "#22252b",
    focus: "#2c3039",
  },

  dark: {
    main: "#e9edf2",
    focus: "#ffffff",
  },

  grey: {
    100: "#2c3039",
    200: "#22252b",
    300: "#3d4249",
    400: "#4a5159",
    500: "#6b7280",
    600: "#9da5b0",
    700: "#b8c0cc",
    800: "#d1d5db",
    900: "#e9edf2",
  },

  gradients: {
    primary: {
      main: "#3CAEA3",
      state: "#20827a",
    },
    secondary: {
      main: "#4a5159",
      state: "#2c3039",
    },
    info: {
      main: "#5794F2",
      state: "#4080e0",
    },
    success: {
      main: "#73BF69",
      state: "#5aa550",
    },
    warning: {
      main: "#FF9830",
      state: "#e88520",
    },
    error: {
      main: "#F2495C",
      state: "#d93548",
    },
    light: {
      main: "#2c3039",
      state: "#22252b",
    },
    dark: {
      main: "#181b1f",
      state: "#111217",
    },
  },

  badgeColors: {
    primary: {
      background: "rgba(60, 174, 163, 0.2)",
      text: "#3CAEA3",
    },
    secondary: {
      background: "rgba(157, 165, 176, 0.2)",
      text: "#9da5b0",
    },
    info: {
      background: "rgba(87, 148, 242, 0.15)",
      text: "#5794F2",
    },
    success: {
      background: "rgba(115, 191, 105, 0.15)",
      text: "#73BF69",
    },
    warning: {
      background: "rgba(255, 152, 48, 0.15)",
      text: "#FF9830",
    },
    error: {
      background: "rgba(242, 73, 92, 0.15)",
      text: "#F2495C",
    },
    light: {
      background: "#22252b",
      text: "#9da5b0",
    },
    dark: {
      background: "#111217",
      text: "#e9edf2",
    },
  },

  coloredShadows: {
    primary: "#3CAEA3",
    secondary: "#22252b",
    info: "#5794F2",
    success: "#73BF69",
    warning: "#FF9830",
    error: "#F2495C",
    light: "#2c3039",
    dark: "#111217",
  },

  inputBorderColor: "#3d4249",

  tabs: {
    indicator: { boxShadow: "#3d4249" },
  },

  // Grafana-specific colors
  borderWeak: "#2c3039",
  borderMedium: "#3d4249",
};

export default darkColors;
